<template>
	<div id='dom' class="page">
		<Tip :tip="tip" />
		<div class="from_div">
			<el-form ref="form" :model="form" label-position="left" label-width="110px">
				<el-form-item v-if="form.consumer_id != ''" label="编号：">
					<span>{{form.consumer_id}}</span>
				</el-form-item>
				<el-form-item label="客户简称：" prop="consumer_name">
					<el-input class="input" v-model="form.consumer_name" clearable placeholder="请输入内容"></el-input>
				</el-form-item>
				<el-form-item label="客户企业名称：" prop="consumer_company">
					<el-input class="input" v-model="form.consumer_company" clearable placeholder="请输入内容"></el-input>
				</el-form-item>
				<el-form-item label="企业LOGO：" prop="consumer_logo" style="margin-bottom: 0;">
					<multiUpload :type='0' :limitImg='1' :noneBtnImg='logoList.length > 0' :fileList="logoList" @saveImg="saveImg" @delImg="delImg"/>
				</el-form-item>
				<el-form-item label="经营行业：" prop="consumer_industry">
					<el-input class="input_" v-model="form.consumer_industry" clearable placeholder="请输入内容"></el-input>
				</el-form-item>
				<el-form-item label="员工人数：" prop="consumer_staffs">
					<el-input class="input_" v-model="form.consumer_staffs" clearable placeholder="请输入内容"></el-input>
				</el-form-item>
				<el-form-item label="企业地址：" prop="consumer_address">
					<el-input class="input_" v-model="form.consumer_address" clearable placeholder="请输入内容"></el-input>
				</el-form-item>
				<el-form-item label="企业概况：" prop="consumer_overview">
					<el-input class="input_" v-model="form.consumer_overview" clearable placeholder="请输入内容"></el-input>
				</el-form-item>
				<el-form-item label="税务分类：" prop="consumer_tax">
					<el-radio-group v-model="form.consumer_tax">
						<el-radio :label="1">一般纳人</el-radio>
						<el-radio :label="2">小规模纳税人</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="税务证号：" prop="consumer_tax_no">
					<el-input class="input_" v-model="form.consumer_tax_no" clearable placeholder="请输入内容"></el-input>
				</el-form-item>
				<el-form-item label="组织架构：" prop="consumer_organization" style="margin-bottom:0">
					<div class="add_div" v-for="(item,index) in form.consumer_organization">
						<div class="item_div">
							<span>职务：</span>
							<el-input class="input_add" v-model="item.duty" clearable placeholder="请输入内容"></el-input>
							<span>姓名：</span>
							<el-input class="input_add" v-model="item.name" clearable placeholder="请输入内容"></el-input>
							<span>电话：</span>
							<el-input class="input_add" v-model="item.phone" clearable placeholder="请输入内容"></el-input>
							<el-button type="primary" plain @click="addItem(index+1)">添加</el-button>
							<el-button v-if="index != 0" type="danger" plain @click="deleteItem(index)">删除</el-button>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="其他备注：" prop="consumer_remark">
					<el-input class="input_" v-model="form.consumer_remark" clearable placeholder="请输入内容"></el-input>
				</el-form-item>
				<el-divider />
				<el-form-item label="客户服务：">
					<span>业务专员：</span>
					<el-select class="select" v-model="form.admin_id" clearable placeholder="选择业务专员">
						<el-option v-for="item in adminList" :key="item.admin_id" :label="item.nick_name"
							:value="item.admin_id" />
					</el-select>
					<span>客户星级：</span>
					<el-select class="select" v-model="form.consumer_star" clearable placeholder="选择客户星级">
						<el-option v-for="item in starList" :key="item.label" :label="item.name" :value="item.label" />
					</el-select>
				</el-form-item>
				<el-divider v-if="type != -1"/>
				<el-form-item v-if="type != -1" label="档案维护：">
					<div class="col">
						<div class="row">
							<span>创建：{{datainfo.created_time}}</span>
							<span style="margin-left: 40px;">操作：{{datainfo.created_admin.nick_name}}-{{datainfo.created_admin.phone}}</span>
						</div>
						<div v-if="datainfo.updated_time != null" class="row">
							<span>修改：{{datainfo.updated_time}}</span>
							<span style="margin-left: 40px;">操作：{{datainfo.updated_admin.nick_name}}-{{datainfo.updated_admin.phone}}</span>
						</div>
					</div>
				</el-form-item>
				<el-divider v-if="type != -1"/>
				<el-form-item v-if="type != -1" label="客户跟进：">
					<span v-if="datainfo.visits.count == 0">暂无客户跟进记录</span>
					<div class="col other" v-for="(item,index) in datainfo.visits.data">
						<div class="col">
							<div class="row">
								<span>时间：{{item.visit_time}}</span>
								<span style="margin-left: 40px;">员工：{{item.admin.nick_name}}-{{item.admin.phone}}</span>
								<span style="margin-left: 40px;">拜访客户：{{item.visit_object}} </span>
								<span style="margin-left: 40px;">拜访方式：{{item.visit_method_text}} </span>
							</div>
							<span>拜访内容：{{item.visit_content}} </span>
							<span>客户回馈：{{item.visit_feedback}} </span>
							<div class="row">
								<span>走访拍照：</span>
								<img class="img_" v-for="(item_,index_) in item.visit_imgs" :src="item_"/>
							</div>
						</div>
					</div>
				</el-form-item>
			</el-form>
		</div>
		<div class="foot_div">
			<el-button @click="close">返回</el-button>
			<el-button type="primary" @click="submitForm('form')">确定</el-button>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import multiUpload from "../../../components/multiUpload/multiUpload.vue"
	import {
		mapGetters
	} from 'vuex';
	import {
		consumerAdd,
		consumerEdit,
		adminLists,
		consumerDetail
	} from "../../../request/apis.js"
	export default {
		props: {
			type: {
				type: Number
			}
		},
		components: {
			Tip,
			multiUpload
		},
		data() {
			return {
				tip: '本页面编辑和查看客户档案信息。',
				logoList:[],//企业logo图片
				starList: [ //客户星级数组
					{
						label: 1,
						name: '一星'
					},
					{
						label: 2,
						name: '二星'
					},
					{
						label: 3,
						name: '三星'
					},
					{
						label: 4,
						name: '四星'
					},
					{
						label: 5,
						name: '五星'
					}
				],
				adminList: [], //业务专员数组
				form: {
					consumer_id: '',
					consumer_name: '', //客户简称
					consumer_company: '', //客户企业名称
					consumer_logo: '', //企业LOGO
					consumer_industry: '', //经营行业
					consumer_staffs: '', //员工人数
					consumer_address: '', //企业地址
					consumer_overview: '', //企业概况
					consumer_tax: '', //税务分类
					consumer_tax_no: '', //税务证号
					consumer_organization: [ //组织架构
						{
							duty: '', //职务
							name: '', //姓名
							phone: '' //电话
						}
					],
					consumer_remark: '', //其他备注
					consumer_star: '', //客户服务-客户星级
					admin_id: '', //客户服务-业务专员
				},
				datainfo:{
					created_admin:'',
					created_time:'',
					updated_admin:'',
					updated_time:'',
					visits:''
				},
				page: 1, //当前页 刷新后默认显示第一页
				limit: 10, //每一页显示的数据量 此处每页显示10条数据
				dialogVisible: false
			}
		},
		computed: {
			...mapGetters(['loginInfo']),
		},
		mounted() {
			this.$watermark.set(this.loginInfo.nick_name + '-' + this.loginInfo.phone.substr(this.loginInfo.phone.length-4), dom);
			if (this.type != -1) {
				//详情编辑
				this.form.consumer_id = this.type;
				this.getConsumerDetail();
			}
			this.getAdminLists();
		},
		methods: {

			//获取客户档案详情
			getConsumerDetail() {
				consumerDetail({
					consumer_id: this.form.consumer_id
				}).then(res => {
					if (res.code == 0) {
						if(res.data.consumer_logo != ''){
							this.logoList.push({url:res.data.consumer_logo})
						}
						for (var key in res.data) {
							if(this.datainfo.hasOwnProperty(key)){
								this.datainfo[key] = res.data[key]
							}
							if (this.form.hasOwnProperty(key)) {
								this.form[key] = res.data[key];
							}
						}
						
						console.log('=as====',this.datainfo);
					}
				}).catch(err => {})
			},

			//获取业务专员列表
			getAdminLists() {
				adminLists({
					page: this.page,
					limit: this.limit
				}).then(res => {
					if (res.code == 0) {
						this.adminList = res.data
					}
				}).catch(err => {})
			},

			//添加组织架构条目
			addItem(index) {
				var obj = {
					duty: '', //职务
					name: '', //姓名
					phone: '' //电话
				}
				this.form.consumer_organization.splice(index, 0, obj)
			},

			//移除组织架构条目
			deleteItem(index) {
				this.form.consumer_organization.splice(index, 1)
			},
			
			//图片存储
			saveImg(arr){
				//企业logo
				this.form.consumer_logo = arr[0];
			},
			
			//图片删除
			delImg(arr){
				//企业logo
				this.form.consumer_logo = '';
				this.logoList = []
			},

			//提交表单
			submitForm(form) {
				this.$refs[form].validate((valid) => {
					if (valid) {
						if (this.type != -1) {
							//编辑
							consumerEdit({
								...this.form
							}).then(res => {
								if (res.code == 0) {
									this.$emit('close', 0)
									this.$message.success(res.msg);
								}else{
									this.$message.error(res.msg);
								}
							}).catch(err => {})
						} else {
							//新增
							consumerAdd({
								...this.form
							}).then(res => {
								if (res.code == 0) {
									this.$emit('close', 0)
									this.$message.success(res.msg);
								}else{
									this.$message.error(res.msg);
								}
							}).catch(err => {})
						}
					} else {
						return false;
					}
				});
			},

			close() {
				this.$emit('close', 1)
			}
		}
	}
</script>

<style scoped>
	.page {
		width: calc(100% - 40px);
		background: #fff;
		position: relative;
		padding: 20px 20px 0 20px;
	}
	
	.col{
		display: flex;
		flex-direction: column;
	}
	
	.row{
		display: flex;
		flex-direction: row;
	}
	
	.other{
		background: #f2f2f2;
		border-radius: 5px;
		padding: 0 10px;
		margin-bottom: 10px;
	}
	
	.img_{
		width: 160px;
		height: 160px;
		margin: 10px 20px 20px 0;
		border-radius: 10px;
		background: #fff;
	}

	.from_div {
		margin-top: 20px;
		width: 100%;
		overflow: scroll;
		height: 644px;
		min-height: 100%;
		padding-bottom: 66px;
	}

	.input {
		width: 200px;
	}

	.input_ {
		width: 435px;
	}

	.add_div {
		display: flex;
		flex-direction: column;
	}

	.item_div {
		display: flex;
		flex-direction: row;
		margin-bottom: 22px;
	}

	.input_add {
		width: 140px;
		margin-right: 50px;
	}

	.select {
		width: 137px;
		margin-right: 20px;
	}

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
	}
</style>